import { Box, Button as MuiButton, Stack, Typography } from '@mui/material';

import ClaimScreen, { ClaimBar } from '@/james-playground/aa-family-claim/ClaimScreen';
import { say, type Voice } from '@/james-playground/aa-family-claim/claim/asks';
import { WELCOME } from '@/james-playground/aa-family-claim/claim/claim.content';

/** The door into the claim: what it is worth, and how the loop works. */
const WelcomeScreen = ({ voice, onStart }: { voice: Voice; onStart: () => void }) => (
  <ClaimScreen
    bar={<ClaimBar />}
    title={say(WELCOME.title, voice)}
    description={say(WELCOME.description, voice)}
    footer={
      <MuiButton variant='contained' size='large' fullWidth onClick={onStart}>
        {WELCOME.primary}
      </MuiButton>
    }
  >
    <Typography variant='body1'>{WELCOME.worth}</Typography>
    <Stack spacing={1.5}>
      <Typography component='h2' variant='overline'>
        {WELCOME.howLabel}
      </Typography>
      <Stack component='ol' sx={{ m: 0, p: 0, listStyle: 'none' }} spacing={2}>
        {WELCOME.how.map((item, i) => (
          <Stack key={item.title} component='li' direction='row' spacing={2}>
            <Box
              aria-hidden
              sx={{
                width: 32,
                height: 32,
                flexShrink: 0,
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                bgcolor: 'custom.limeGreen.200',
                color: 'primary.main',
                fontWeight: 600,
              }}
            >
              {i + 1}
            </Box>
            <Stack spacing={0.25}>
              <Typography variant='h6'>{say(item.title, voice)}</Typography>
              <Typography variant='body2'>{say(item.body, voice)}</Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  </ClaimScreen>
);

export default WelcomeScreen;
